import { styled } from "styled-components";

export const ModalContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  flex-grow: 1;
  width: 100%;
  height: 1%;
`;
